import { apiClient } from '_shared/dataFetching/apiConfig';

export const matchService = {
  async getMatch({ matchId }) {
    const url = `match/${matchId}`;
    const res = await apiClient.get(url);
    const data = res.data;
    return data;
  }
};
